var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loaded
    ? _c("div", [
        _c("div", { staticClass: "caseStudiesWrap" }, [
          _c("div", { staticClass: "caseStudiesCategoriesWrap" }, [
            _c(
              "div",
              { staticClass: "caseStudiesCategories" },
              _vm._l(_vm.categories, function(name, key) {
                return _vm.categoryCounts[key] === undefined ||
                  _vm.categoryCounts[key] > 0
                  ? _c(
                      "a",
                      {
                        key: key,
                        staticClass: "caseStudiesCategory",
                        class: { active: _vm.selected_category == key },
                        style: { color: "#fff" },
                        attrs: {
                          href:
                            "/technology-solutions/" + key.replace(/_/g, "-")
                        }
                      },
                      [_c("span", [_vm._v(_vm._s(name))])]
                    )
                  : _vm._e()
              }),
              0
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "caseStudiesMobile" }, [
            _c("div", { staticClass: "selectWrap" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.selected_category,
                      expression: "selected_category"
                    }
                  ],
                  on: {
                    change: [
                      function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.selected_category = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                      function($event) {
                        return _vm.changeCategory(_vm.selected_category)
                      }
                    ]
                  }
                },
                _vm._l(_vm.categories, function(category, key) {
                  return _vm.showCategory(key)
                    ? _c("option", { domProps: { value: key } }, [
                        _vm._v(_vm._s(category))
                      ])
                    : _vm._e()
                }),
                0
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "caseStudiesBody swiperLight" }, [
            _vm.loading
              ? _c("div", { staticClass: "loader" }, [
                  _c("i", { staticClass: "fas fa-circle-notch fa-spin" })
                ])
              : _vm.products.length > 0
              ? _c(
                  "div",
                  { staticClass: "slideGrid" },
                  _vm._l(_vm.products, function(product) {
                    return _c(
                      "a",
                      { staticClass: "gridItem", attrs: { href: product.url } },
                      [
                        _c("div", {
                          staticClass: "itemImage",
                          style: {
                            backgroundImage:
                              "url(" + _vm.getImage(product) + ")"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "itemMain" }, [
                          _c("div", { staticClass: "itemMainInner" }, [
                            _c("h3", [_vm._v(_vm._s(product.data.post_title))]),
                            _vm._v(" "),
                            _c("p", [_vm._v("More")])
                          ])
                        ])
                      ]
                    )
                  }),
                  0
                )
              : _c("div", { staticClass: "noCaseStudies" }, [
                  _vm._v("\n                No products found\n            ")
                ])
          ])
        ])
      ])
    : _c("div", { staticClass: "loader" }, [
        _c("i", { staticClass: "fas fa-circle-notch fa-spin" })
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }